import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckoutBreadcrumbs from "./CheckoutBreadcrumbs";
import { getCheckout, setCheckout } from "../utils/buyNowStorage";

const PaymentPage = () => {
  const navigate = useNavigate();
  const checkout = getCheckout();

  const [method, setMethod] = useState("");
  const [upiId, setUpiId] = useState("");
  const [card, setCard] = useState({ number: "", expiry: "", cvv: "" });
console.log("Checkout Data:", checkout);
  useEffect(() => {
    if (!checkout?.items?.length || !checkout?.addressId) {
      navigate("/", { replace: true });
    }
  }, []);

  const handlePay = () => {
    console.log("Processing payment with method:", method);
    if (!method) return alert("Select payment method");
    if (method === "upi" && !upiId) return alert("Enter UPI ID");
    if (method === "card" && (!card.number || !card.expiry || !card.cvv))
      return alert("Enter card details");
    
    setCheckout({ ...checkout, method });

    setTimeout(() => {
      navigate("/order-success");
    }, 0);
  };

  if (!checkout) return null;

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", mt: 4 }}>
      <CheckoutBreadcrumbs active={2} />

      <Paper sx={{ p: 3 }}>
        <Typography fontWeight={700}>Payment Method</Typography>

        <RadioGroup
          value={method}
          onChange={(e) => setMethod(e.target.value)}
        >
          <FormControlLabel value="cod" control={<Radio />} label="Cash on Delivery" />
          <FormControlLabel value="upi" control={<Radio />} label="UPI" />
          <FormControlLabel value="card" control={<Radio />} label="Card" />
        </RadioGroup>
{method === "upi" && (
          <TextField
            label="Enter UPI ID"
            fullWidth
            sx={{ mt: 2 }}
            value={upiId}
            onChange={(e) => setUpiId(e.target.value)}
          />
        )}
        {method === "card" && (
          <>
            <TextField
              label="Card Number"
              fullWidth
              sx={{ mt: 2 }}
              value={card.number}
              onChange={(e) =>
                setCard({ ...card, number: e.target.value })
              }
            />
            <TextField
              label="Expiry (MM/YY)"
              fullWidth
              sx={{ mt: 2 }}
              value={card.expiry}
              onChange={(e) =>
                setCard({ ...card, expiry: e.target.value })
              }
            />
            <TextField
              label="CVV"
              fullWidth
              sx={{ mt: 2 }}
              value={card.cvv}
              onChange={(e) =>
                setCard({ ...card, cvv: e.target.value })
              }
            />
          </>
        )}
        <Button fullWidth sx={{ mt: 3 }} variant="contained" onClick={handlePay}>
          Pay Now
        </Button>
      </Paper>
    </Box>
  );
};

export default PaymentPage;
